import { zodSelectPlayerPreferences } from '../../generated/zodSchemas.generated';
import { z } from 'zod';

// Specifying for when other player preferences are put in this table
export const ZPlayerPreferencesEmailSelect = zodSelectPlayerPreferences.pick({
  playerId: true,
  agreedToMarketing: true,
  drawReminderEmails: true,
  dprReminders: true, // Daily Raffle
  notifyResults: true, // weekly draws
  notifyResultsDailyChallenger: true,
  notifyResultsLeaderboard: true,
  notifyResultsRaffles: true,
  notifyResultsMinilottos: true,
});

export const ZPlayerPreferencesEmailSettings = z.object({
  agreedToMarketing: z.boolean().optional(),
  drawReminderEmails: z.boolean().optional(),
  dprReminders: z.boolean().optional(), // Daily Raffle
  notifyResults: z.boolean().optional(), // weekly draws
  notifyResultsDailyChallenger: z.boolean().optional(),
  notifyResultsLeaderboard: z.boolean().optional(),
  notifyResultsRaffles: z.boolean().optional(),
  notifyResultsMinilottos: z.boolean().optional(),
});
export type TPlayerPreferencesEmails = z.infer<
  typeof ZPlayerPreferencesEmailSettings
>;

// extend this when player preferences are added which aren't email related
export const ZPlayerPreferencesSettings = ZPlayerPreferencesEmailSettings;
export type TPlayerPreferencesSettings = z.infer<
  typeof ZPlayerPreferencesSettings
>;
